(function () {
  let announcementSwipers = new Map();

  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");

    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) observer.observe(annBar);
    };
    createObserver();
  };

  const initAnnouncementSwiper = (section) => {
    const swiperContainer = section.querySelector('.announcement-bar__swiper');
    if (!swiperContainer) return;

    const sectionId = section.id;
    
    // Destroy existing swiper if it exists
    if (announcementSwipers.has(sectionId)) {
      announcementSwipers.get(sectionId).destroy(true, true);
      announcementSwipers.delete(sectionId);
    }

    // Get settings from data attributes or section settings
    const enableSlider = section.dataset.enableSlider !== 'false';
    const slideDuration = parseInt(section.dataset.slideDuration) || 4;
    const showNavigation = section.dataset.showNavigation === 'true';
    const showPagination = section.dataset.showPagination === 'true';
    const pauseOnHover = section.dataset.pauseOnHover !== 'false';
    const loop = section.dataset.loop !== 'false';

    if (!enableSlider) return;

    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: loop,
      autoplay: {
        delay: slideDuration * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover,
      },
      navigation: showNavigation ? {
        nextEl: swiperContainer.querySelector('.swiper-button-next'),
        prevEl: swiperContainer.querySelector('.swiper-button-prev'),
      } : false,
      pagination: showPagination ? {
        el: swiperContainer.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 500,
      allowTouchMove: false,
      watchOverflow: true,
    });

    announcementSwipers.set(sectionId, swiper);
  };

  const destroyAnnouncementSwiper = (section) => {
    const sectionId = section.id;
    if (announcementSwipers.has(sectionId)) {
      announcementSwipers.get(sectionId).destroy(true, true);
      announcementSwipers.delete(sectionId);
    }
  };

  // Initialize announcement bar
  const initAnnouncementBar = () => {
    const sections = document.querySelectorAll('.section-announcement');
    sections.forEach(section => {
      initAnnBar();
      initAnnouncementSwiper(section);
    });
  };

  // Event listeners for Shopify section events
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.classList.contains('section-announcement')) {
      initAnnBar();
      initAnnouncementSwiper(event.target);
    }
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (event.target.classList.contains('section-announcement')) {
      destroyAnnouncementSwiper(event.target);
    }
  });

  document.addEventListener("shopify:section:reorder", initAnnouncementBar);
  document.addEventListener("shopify:section:select", (event) => {
    if (event.target.classList.contains('section-announcement')) {
      // Pause autoplay when section is being edited
      const sectionId = event.target.id;
      if (announcementSwipers.has(sectionId)) {
        announcementSwipers.get(sectionId).autoplay.stop();
      }
    }
  });

  document.addEventListener("shopify:section:deselect", (event) => {
    if (event.target.classList.contains('section-announcement')) {
      // Resume autoplay when section editing is done
      const sectionId = event.target.id;
      if (announcementSwipers.has(sectionId)) {
        announcementSwipers.get(sectionId).autoplay.start();
      }
    }
  });

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementBar);
  } else {
    initAnnouncementBar();
  }
})();
